export default __webpack_public_path__ + "static/media/IMG_5000-min.3d3fee4c.JPG";